module.exports = __webpack_public_path__ + "static/img/bqzk.7b1f8ccc.png";